import React from "react";
import { motion } from "framer-motion";
import {
  Section,
  VideoWrap,
  VideoContainer,
  VideoWrapper,
  Video,
} from "../styles/sections/VideoSectionStyles";

function VideoSection() {
  return (
    <Section>
      <VideoWrap data-framer-name="Wrap">
        <VideoWrapper
          initial={{ opacity: 0, scale: 0.9 }}
          whileInView={{ opacity: 1, scale: 1 }}
          transition={{ duration: 0.8 }}
          viewport={{ once: true }}
          role="presentation"
        >
          <Video
            title="Youtube Video"
            allow="presentation; fullscreen; accelerometer; autoplay; encrypted-media; gyroscope; picture-in-picture"
            src="https://www.youtube.com/embed/jAoeL6rkiRI?iv_load_policy=3&rel=0&modestbranding=1&playsinline=1&autoplay=1&mute=1&loop=1&playlist=jAoeL6rkiRI&controls=0"
            frameBorder="0"
          />
        </VideoWrapper>
      </VideoWrap>
    </Section>
  );
}

export default VideoSection;
